import { HimuraInject } from 'himura';
import * as T_T from 'cryface';
import { CommonConfig } from '../configs/config.common';

@HimuraInject.NamedService('SkittleManager')
export class SkittleManager {

    public groups = [
        {
            key: 'helpdesk',
            value: [
                'showings',
                'listings',
                'reports',
            ]
        },
        {
            key: 'resources',
            value: [
                'pre-sale',
                'rifo-exlusive',
                'my-frontstore'
            ]
        },
        {
            key: 'data analytics',
            value: [
                'daily-report',
                'listing-presentation',
                'timeseries',
                'nuero-network',
            ]
        },
    ];

    private configs = [
        {
            name: 'default',
            color: 'rgb(41, 183, 209)',
            icon: 'coffee',
            link: '/',
            tipTitle: 'Dedfault',
            tip: 'PlaceHolder Application'
        },
        {
            name: 'showings',
            color: 'rgb(41, 209, 186)',
            icon: 'calendar-alt',
            link: '/showings',
            tipTitle: 'Showings',
            tip: 'Showing appointments.'
        },
        {
            name: 'listings',
            color: 'rgb(41, 153, 209)',
            icon: 'list',
            link: '/listings',
            tipTitle: 'Listings',
            tip: 'Information about Listings'
        },
        {
            name: 'daily-report',
            color: 'rgb(1, 160, 157)',
            icon: 'clipboard',
            link: new CommonConfig().dailyReportUrl,
            tipTitle: 'Daily-Report',
            tip: 'Properties Daily Report, RIFO Made.',
            linkType: 'hyperLink'
        },
        {
            name: 'my-frontstore',
            color: 'rgb(204, 178, 86)',
            icon: 'store',
            link: '/frontstore/setting',
            tipTitle: 'My Frontstore',
            tip: 'Manage Your Own Frontstore',
        },
        {
            name: 'listing-presentation',
            color: 'rgb(184, 77, 70)',
            icon: 'file-powerpoint',
            link: '/listing-presentation/lists',
            tipTitle: 'Listing Presentation Tools',
            tip: 'Better Presentations, Better Business.',
        },
        {
            name: 'reports',
            color: 'rgb(255, 237, 40)',
            icon: 'clipboard',
            link: '/reports',
            tipTitle: 'Reports',
            tip: 'Message sent reports.'
        },
        {
            name: 'pre-sale',
            color: 'rgb(244, 166, 65)',
            icon: 'building',
            link: '/presales',
            tipTitle: 'Pre-sale',
            tip: 'Manage pre-sale properties.'
        },
        {
            name: 'rifo-exlusive',
            color: 'rgb(0, 154, 191)',
            icon: 'certificate',
            link: '/rifo/exlusives',
            tipTitle: 'Rifo-Exlusive',
            tip: 'Manage exlusive properties.'
        },
        {
            name: 'nuero-network',
            color: 'rgb(175, 63, 95)',
            icon: 'project-diagram',
            link: '/',
            tipTitle: 'Nuero Network',
            tip: 'Coming soon'
        },
        {
            name: 'timeseries',
            color: 'rgb(128, 160, 102)',
            icon: 'clock',
            link: '/',
            tipTitle: 'Time Series',
            tip: 'Coming Soon'
        },
    ];

    public getSkittleConfig(name: string) {
        const result = this.configs.find((config: any) => {
            return config.name.toLowerCase().trim() === name.toLowerCase().trim();
        });
        return T_T.simpleDetect(result) ? result : this.configs[0];
    }
}
